import { debug } 		from './theme/debug.js';
import { helpers } 		from './theme/helpers.js';

import { hamburger } 	from './theme/components/hamburger.js';
// import { sliders } 	from './theme/components/sliders.js';
import { modal }		from './theme/components/modal.js';
import { map } 			from './theme/components/map.js';
import { faq } 			from './theme/components/faq.js';
import { calc } 		from './theme/components/calc.js';
import { filter } 		from './theme/components/filter.js';

window.theme = {
	globals: {
		enablePjax: true,
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		greenAlertCheck: false,
		lastScroll: 0,
	},
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();
		self.touch();

		// sliders.init();
		modal.init();
		hamburger.init();
		map.init();
		faq.init();
		calc.init();
		filter.init();

		self.loadFancy();

		jQuery( '.navigation__primary .header-nav__item--separator' ).remove();

		if( jQuery( '.login-alert' ).length ) {
			jQuery( '.login-alert' ).parent().append( loginAlert );
		}
	},
	loadFancy: function(){
		jQuery(".fancybox").fancybox();
	},
	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},
	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	smoothScroll: {
		selector: 'a[href*="#"]',
		init: function () {
			var self = this,
				scroll = new SmoothScroll(self.selector, {
					ignore: '[data-scroll-ignore]',
					topOnEmptyHash: false,
					speed: 1000,
					offset: 150,
					updateURL: false,
					easing: 'easeInOutCubic',
				});
		},
	},
	responsiveBackgroundImage: {
		selector: '*[data-mobile-background-image]',
		init: function () {
			var self = this,
				$elements = jQuery(self.selector),
				viewportWidth = jQuery(window).width();

			$elements.each(function () {
				var $element = jQuery(this),
					mobileBackgroundImageUrl = $element.attr('data-mobile-background-image');

				if (viewportWidth <= 992) {
					$element.css('background-image', 'url("' + mobileBackgroundImageUrl + '")');
				}
			});
		},
	},
	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
	},
	onscroll(position, previusPosition) {
		var self = this;

		var currentScroll = self.windowPosition()['y'];

		var fixedHeader = currentScroll > 0;
		var scrollUp = "scroll-up";
		var scrollDown = "scroll-down";
		var body = document.querySelector('body');

		if ( fixedHeader ) {
			body.classList.add('fixed-header');

			if( currentScroll >= 100 ) {
				if (currentScroll > self.globals.lastScroll && !body.classList.contains(scrollDown)) {
					// down
					body.classList.remove(scrollUp);
					body.classList.add(scrollDown);
				} else if (currentScroll < self.globals.lastScroll && body.classList.contains(scrollDown)) {
					// up
					body.classList.remove(scrollDown);
					body.classList.add(scrollUp);
				}
			} else {
				body.classList.remove(scrollUp);
				body.classList.remove(scrollDown);
			}

			self.globals.lastScroll = currentScroll;
		} else {
			document.querySelector('body').classList.remove('fixed-header');
		}
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	// theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 